/* eslint-disable no-template-curly-in-string */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// DS
import {
  Col,
  Row,
  VertSelect,
  Form,
  VertInput,
  Typography,
  Space,
  VertTypography,
  Image,
} from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Forms/FormsMethodPaymentStyles.less';
import { CreditCardOutlined } from '@ant-design/icons';
import usePipeContext from 'Services/Providers/PipeProvider/usePipeContext';
import generateUUID from 'Utils/generateUUID';
import { useSelector } from 'react-redux';
import { ValidationCreditCard } from 'Utils/validationCreditCard';
import { allPropertiesFilled } from 'Utils/allPropertiesFilled';
import { extractNumber } from 'Utils/onlyNumbers';
import { LuCreditCard } from 'react-icons/lu';
import Icon from 'components/Atoms/Icons/Icon';
import { validateCPF } from 'Utils/validadeDocuments';
import { getOnlyNumbers } from 'Utils/format';
import { isValid, parse } from 'date-fns';
import CardBrand from 'components/Checkout/CheckoutPayment/PaymentScoreMoreMoney/components/CardBrand';
import { useCheckoutProvider } from 'components/Checkout/CheckoutProvider';
import ynToBool from 'Utils/ynToBool';

// MOCK
const listMethodPayment = [
  {
    value: 'credito',
    label: (
      <>
        <CreditCardOutlined />
        <Typography.Text style={{ margin: '0 var(--spacing-small)' }}>
          Cartão de crédito
        </Typography.Text>
      </>
    ),
    availability: true,
  },
];

if (!ynToBool(process.env.REACT_APP_HIDE_DEBIT_COMPLEMENT)) {
  listMethodPayment.push({
    value: 'debito',
    label: (
      <>
        <CreditCardOutlined />
        <Space />
        <Typography.Text style={{ margin: '0 var(--spacing-small)' }}>
          Cartão de débito
        </Typography.Text>
      </>
    ),
    availability: true,
    children: <CreditCardOutlined />,
  });
}

const MethodPaymentCreditOrDebit = ({ ...props }) => {
  const { setCredicard } = useCheckoutProvider();
  const { listInstallments, isLoading, getInfosCheckout, cardBrands, method } =
    props;
  const [form] = Form.useForm();

  const [cardBrandId, setCardBrandId] = useState({});
  const [fieldsError, setFieldsError] = useState([]);
  const [suffixCardBrand, setSuffixCardBrand] = useState({
    suffix: (
      <Icon
        className="lucide color-detached"
        size={`18px`}
        component={LuCreditCard}
      />
    ),
  });

  useEffect(() => {
    if (isLoading === true) {
      form.resetFields(['installments']); //Reseto campo de parcelamento, pois o usuário mudou as condições de pagamento
    }
  }, [isLoading]);

  const onFormValuesChange = (changedValues, allValues) => {
    /* BLOCO NECESSARIO PARA VERIFICAR QUAIS CAMPOS ESTÃO COM ERRO */
    /* POR ALGUM MOTIVO O ANTD DISPARA QUE SEMPRE HÁ ERRO NO FORM, MESMO PASSANDO NA VALIDACAO */

    const errors = form.getFieldsError();
    const formFieldsValidation = [];

    for (const fieldName of Object.keys(changedValues)) {
      const fieldValue = allValues[fieldName];
      const cleanedValue = fieldValue.replace(/[_\s]/g, ''); // Remove todos os espaços e underscores
      if (cleanedValue === '') {
        formFieldsValidation.push(fieldName);
      }
    }

    const hasErrors = errors.some((field) => field.errors.length > 0);
    if (hasErrors) {
      errors.forEach((field) => {
        const { name, errors } = field;
        if (errors.length > 0) {
          formFieldsValidation.push(name[0]);
        }
      });
    }

    let cardBrand = null;
    /* INSERIR ICONE DO CARTAO NO INPUT */
    if (changedValues?.numberCard) {
      if (cardBrands.length === 0) {
        return null;
      }
      const numberCard = extractNumber(changedValues.numberCard);
      cardBrand = cardBrands.find((item) =>
        RegExp(item.regexValidation).test(`${numberCard}`)
      );

      if (cardBrand) {
        setCredicard({
          brand: cardBrand,
        });
      }

      if (cardBrand?.id && cardBrand?.imageUrl) {
        setCardBrandId(cardBrand?.id || 0);
        setSuffixCardBrand({
          suffix: (
            <img src={cardBrand.imageUrl} style={{ maxHeight: '18px' }} />
          ),
        });
      } else if (
        cardBrand &&
        cardBrand?.id !== undefined &&
        cardBrand?.id !== null
      ) {
        setCardBrandId(cardBrand?.id || 0);
      }
    }

    /* VERIFICAR SE ENVIAMOS AS INFOS OU TRAVAMOS O BOTAO */
    if (formFieldsValidation.length > 0) {
      if (!fieldsError.includes(Object.keys(changedValues)[0])) {
        setFieldsError([...fieldsError, Object.keys(changedValues)[0]]);
        getInfosCheckout({}, true); //reset as infos de pagamento
      }
    } else if (allPropertiesFilled(allValues)) {
      setFieldsError([]);
      let tempInstalments = {};
      if (method === 'debito') {
        tempInstalments = {
          installments: listInstallments[0].value,
        };
      }
      listInstallments;
      const completedValues = {
        ...allValues,
        ...tempInstalments,
        cardBrandId: cardBrand && cardBrand?.id ? cardBrand?.id : cardBrandId,
      };
      getInfosCheckout(completedValues, false);
    }
  };
  return (
    <div className='formMethodPayment'
    
    >
      <Form
        name="basic"
        form={form}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        initialValues={{ remember: true }}
        autoComplete="off"
        layout="vertical"
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--spacing-regular)',
        }}
        onValuesChange={onFormValuesChange}
      >
        <>
          <Form.Item
            name="numberCard"
            label="Número do Cartão"
            rules={[
              { required: true, message: '${label} precisa ser preenchido.' },
              {
                validator: (rule, value) => {
                  if (!ValidationCreditCard(value)) {
                    return Promise.reject('Número do Cartão inválido');
                  }
                  return Promise.resolve();
                },
              },
            ]}
            style={{ marginBottom: 0 }}
          >
            <VertInput
              mask="0000 0000 0000 0000"
              {...suffixCardBrand}
              disabled={isLoading}
              className="input-form-method-payment"
            />
          </Form.Item>
          <Form.Item
            name="expirationDate"
            label="Validade"
            style={{
              display: 'inline-block',
              width: 'calc(50% - 8px)',
              margin: '0 16px 0 0',
            }}
            rules={[
              { required: true, message: '${label} precisa ser preenchido.' },
              {
                validator: (_, value) => {
                  const formattedDate = value.replace(/\s/g, '');
                  if (isValid(parse(formattedDate, 'MM/yy', new Date()))) {
                    return Promise.resolve();
                  }
                  return Promise.reject('Data de validade inválida.');
                },
              },
            ]}
          >
            <VertInput
              mask="00/00"
              disabled={isLoading}
              className="input-form-method-payment"
            />
          </Form.Item>

          <Form.Item
            name="cvv"
            label="CVV"
            style={{
              display: 'inline-block',
              width: 'calc(50% - 8px)',
              margin: 0,
            }}
            rules={[
              { required: true, message: '${label} precisa ser preenchido.' },
              {
                validator: (_, value) => {
                  if (/^\d+$/.test(value)) {
                    return Promise.resolve();
                  }
                  return Promise.reject('CVV deve conter apenas números.');
                },
              },
            ]}
          >
            <VertInput
              disabled={isLoading}
              maxLength={4}
              className="input-form-method-payment"
            />
          </Form.Item>

          <Form.Item
            name="nameCard"
            label="Nome Impresso no Cartão"
            rules={[
              { required: true, message: '${label} precisa ser preenchido.' },
            ]}
            style={{ margin: 0 }}
          >
            <VertInput
              type="text"
              disabled={isLoading}
              className="input-form-method-payment"
            />
          </Form.Item>
          <Form.Item
            name="cpfNumber"
            label="CPF do portador do cartão"
            rules={[
              { required: true, message: '${label} precisa ser preenchido.' },
              {
                validator: (rule, value) => {
                  if (!validateCPF(value)) {
                    return Promise.reject('CPF inválido');
                  }
                  return Promise.resolve();
                },
              },
            ]}
            style={{ marginBottom: 0 }}
          >
            <VertInput
              mask="000.000.000-00"
              disabled={isLoading}
              className="input-form-method-payment"
            />
          </Form.Item>
          <Form.Item
            name="installments"
            label="Número de Parcelas"
            rules={[
              { required: true, message: '${label} precisa ser preenchido.' },
            ]}
            style={{ margin: 0 }}
          >
            <VertSelect
              items={listInstallments}
              showSearch
              placeholder="Número de Parcelas"
              disabled={isLoading}
              verticalSpacingSelect='extra-small'
            />
          </Form.Item>
        </>
      </Form>
    </div>
  );
};

MethodPaymentCreditOrDebit.propTypes = {
  listInstallments: PropTypes.array,
  isLoading: PropTypes.bool,
};

// FORMS METHOD PAYMENT COMPONENT
const FormsMethodPayment = ({ ...props }) => {
  const {
    onChange,
    pointsSelected,
    cashSelected,
    handleCheckoutInfos,
    loading,
  } = props;

  /* HOOKS */
  const { callApi } = usePipeContext();
  const { setCredicard } = useCheckoutProvider();

  const [isLoading, setLoading] = useState(loading);
  const [cardBrands, setCardBrands] = useState([]);

  const [form, setForm] = useState({
    method: '',
    numberCard: '',
    expirationDate: '',
    cvv: '',
    nameCard: '',
    cpfNumber: '',
    installments: '',
  });

  const [listInstallments, setListInstallments] = useState([]);

  /* REDUCERS */
  const PaymentConfig = useSelector(({ PaymentConfig: data }) => data);
  const { paymentConfig: PointsAndCashConfig } = PaymentConfig;
  const PaymentInstallments = useSelector(
    ({ PaymentInstallments: data }) => data
  );

  /* LIFE CYCLES  */
  useEffect(() => {
    if (
      PaymentConfig?.finishRequests &&
      PointsAndCashConfig?.isExecutePointAndCash &&
      PointsAndCashConfig?.isAbilityInCampaing
    ) {
      if (PointsAndCashConfig?.cardBrandModel) {
        setCardBrands(PointsAndCashConfig?.cardBrandModel);
      }
    }
  }, [PaymentConfig?.finishRequests]);
  useEffect(() => {
    if (
      PaymentInstallments?.finishRequests &&
      PaymentInstallments?.isError === false
    ) {
      calculateNumberInstallments(PaymentInstallments?.paymentInstallments);
    }
  }, [PaymentInstallments?.finishRequests]);

  useEffect(() => {
    setLoading(PaymentInstallments?.isLoading);
  }, [PaymentInstallments?.isLoading]);

  useEffect(() => {
    if (form.method && form.method === 'credito') {
      const { maxPointForCash, totalOrder } = PointsAndCashConfig;

      const pointsDiff =
        maxPointForCash - pointsSelected < 0
          ? totalOrder - maxPointForCash
          : totalOrder - pointsSelected;

      callApi({
        symbol: 'FETCH_POINTS_CASH_INSTALLMENTS',
        alias: generateUUID(),
        payload: {
          PointsCash: pointsDiff,
        },
      });
    }
  }, [form.method, pointsSelected]);

  /* HANDLES */
  const handleChange = (target, value) => {
    setForm({ ...form, [target]: value });
    onChange({ target, value });
  };

  const calculateNumberInstallments = (paymentInstallments) => {
    let listPaymentInstallments = paymentInstallments;
    if (form.method === 'debito') {
      listPaymentInstallments = [paymentInstallments[0]];
    }
    const listMapeed = listPaymentInstallments.map((installment, index) => {
      return {
        value: JSON.stringify(installment),
        label: `${installment.description}`,
      };
    });
    setListInstallments(listMapeed);
  };

  const getInfosCheckout = (infos, reset) => {
    if (!reset) {
      const {
        numberCard,
        cardBrandId,
        nameCard,
        installments,
        cpfNumber,
        cvv,
        expirationDate,
      } = infos;

      //Informações do comprado
      const creditCard = numberCard;
      const cardHolderName = nameCard;
      const cardBrandSelected = cardBrandId;
      const validityDateParts = expirationDate.split('/');
      const installmentSelected = JSON.parse(installments);
      const installment = installmentSelected.parcel;
      const installmentValue = installmentSelected.parcelValue;

      //Informações do pedido
      const { maxPointForCash, totalOrder } = PointsAndCashConfig;
      const pointsValue =
        maxPointForCash - pointsSelected < 0
          ? totalOrder - maxPointForCash
          : totalOrder - pointsSelected;

      const purchaseInfos = {
        cardBrandId: cardBrandSelected,
        cardHolderName: cardHolderName,
        cardHolderCPF: cpfNumber,
        cardNumber: getOnlyNumbers(creditCard),
        expirationMonth: validityDateParts[0],
        expirationYear: validityDateParts[1],
        securityCode: getOnlyNumbers(cvv),
        installments: installment,
        installmentValue: installmentValue,
        pointsValue: pointsValue,
        pointsSelected: pointsSelected,
        cashSelected: cashSelected,
        methodPayment: form.method,
        isValid: true,
      };

      setCredicard({
        validityDate: `${validityDateParts[0]}/${validityDateParts[1]}`,
        number: purchaseInfos.cardNumber,
        cpfNumber: purchaseInfos.cardHolderCPF,
        personName: purchaseInfos.cardHolderName,
        installments: {
          parcel: purchaseInfos.installments,
        },
        cvv: purchaseInfos.securityCode,
      });

      if (allPropertiesFilled(purchaseInfos)) {
        sendCheckoutInfos(purchaseInfos);
      }
    } else {
      const purchaseInfos = {
        cardBrandId: null,
        cardHolderName: null,
        cardHolderCPF: null,
        cardNumber: null,
        expirationMonth: null,
        expirationYear: null,
        securityCode: null,
        installments: null,
        installmentValue: null,
        pointsValue: null,
        cashSelected: null,
        methodPayment: null,
        isValid: false,
      };
      setCredicard({
        validityDate: null,
        number: purchaseInfos.cardNumber,
        cpfNumber: purchaseInfos.cardHolderCPF,
        personName: purchaseInfos.cardHolderName,
        installments: {
          parcel: purchaseInfos.installments,
        },
        cvv: purchaseInfos.securityCode,
      });
      sendCheckoutInfos(purchaseInfos);
    }
  };

  const sendCheckoutInfos = (infos = {}) => {
    handleCheckoutInfos(infos);
  };

  const methodPayment = () => {
    switch (form.method) {
      case 'debito':
      case 'credito':
        return (
          <MethodPaymentCreditOrDebit
            method={form.method}
            cardBrands={cardBrands}
            getInfosCheckout={getInfosCheckout}
            isLoading={isLoading}
            listInstallments={listInstallments}
          />
        );
      default:
        break;
    }
  };

  return (
    <Col className="forms-method-payment-wrapper col-12">
      <VertTypography.Text>Bandeiras aceitas</VertTypography.Text>
      <Row gutter={[16, 16]} className="card-brand-accept">
        {cardBrands.map(({ imageUrl, name }, index) => (
          <CardBrand imageUrl={imageUrl} key={index} name={name} />
        ))}
      </Row>

      <Row>
        <VertSelect
          options={listMethodPayment}
          value={form.method}
          showSearch
          placeholder="Selecione a forma de pagamento"
          onSelect={(value) => handleChange('method', value)}
        />
      </Row>
      <Row>
        <Col className="col-12">{methodPayment()}</Col>
      </Row>
    </Col>
  );
};

FormsMethodPayment.propTypes = {
  amountToPay: PropTypes.number,
  onChange: PropTypes.func,
  isValid: PropTypes.func,
  handleCheckoutInfos: PropTypes.func.isRequired,
  pointsSelected: PropTypes.number.isRequired,
  cashSelected: PropTypes.string.isRequired,
  loading: PropTypes.bool,
};

export default FormsMethodPayment;
